import { WarningAlt } from "@carbon/icons-react";
import { type FC } from "react";

import { Banner } from "@moment/design-system/Banner";

export const ProductionBanner: FC = () => {
	return (
		<Banner
			variant="negative"
			level="primary"
			icon={<WarningAlt />}
			title="Warning!"
			message="You are currently working with Production Data. Use with care!"
		/>
	);
};
